import router from "../../router";
import { parse } from "query-string";
import request from "@/utils/request";
import { setAuthority, clearAuthority } from "@/utils/authority";
import domain from "../../domain";
import { notification } from "ant-design-vue";

const state = {
  status: 0 //status - 2 login; 1 not login;
};

const actions = {
  async login({ commit }, payload) {
    const {userName,password} = payload
    let post_params = {"account":userName,"password":password}
    console.log(domain.URLS.Login_Url);
    const response = (await request({
      url: domain.URLS.Login_Url,
      method: "POST",
      data: post_params,
      timeout: 5000
    })).data;

    commit("changeLoginStatus", response);
    // Login successfully
    if (response.ReturnCode === 0) {
      const urlParams = new URL(window.location.href);
      let redirect = parse(location.search).redirect;
      if (redirect) {
        const redirectUrlParams = new URL(redirect);
        if (redirectUrlParams.origin === urlParams.origin) {
          redirect = redirect.substr(urlParams.origin.length);
          const searchSubstring = "/hpm";
          const indexOfSubstring = redirect.indexOf(searchSubstring);
          if (indexOfSubstring !== -1){
            redirect = redirect.substring(indexOfSubstring + searchSubstring.length);
          }
          redirect = redirect.substr()
          if (redirect.match(/^\/.*#/)) {
            redirect = redirect.substr(redirect.indexOf("#") + 1);
          }
        } else {
          redirect = null;
        }
      }
      router.replace({ path: redirect || "/" });
    } else {
      notification.error({
        // eslint-disable-next-line no-unused-vars
        message: h => (
          <div>
            <span style="color: red">登录失败</span>
          </div>
        ),
        description: '请检查你的账号和密码'
      });
    }
  },
  async logout({ commit }) {
    commit("changeLoginStatus", {
      ReturnCode: 10002
    });
    const redirect = parse(location.search).redirect;
    // redirect
    if (window.location.pathname !== "/user/login" && !redirect) {
      router.replace({
        path: "/user/login",
        query: {
          redirect: window.location.href
        }
      });
    }
  },
  async register({ commit }, payload) {
    console.log(payload);
    const response = (await request({
      url: "/api/register",
      method: "POST",
      data: payload
    })).data;
    console.log(response);
    if (response.status === "ok") {
      commit("changeLoginStatus", response);
      router.push({
        name: "register.result",
        params: {
          account: payload.mail
        }
      });
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getCaptcha({ commit }, payload) {
    console.log(payload);
    await request({
      url: `/api/captcha?mobile=${payload.mobile}`,
      method: "GET"
    });
  }
};

const mutations = {
  changeLoginStatus(state, payload) {
    if(payload.ReturnCode == 0){
      state.status = 2;
      setAuthority(payload.Data);
    }
    else {
      state.status = 1;
      clearAuthority();
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
